import { useLanguage } from './../../../utilities/LanguageContext'


const Credits = () => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto

    // Obtiene el año actual del sistema
    const currentYear = new Date().getFullYear()

    return (
        <p>{translate('labels.credits.footer')} {currentYear} - v5.0.0</p>
    )
}

export { Credits };